import Joi from 'joi';
import { constants } from './constant';

const ValidationSchema = {
  uuid: Joi.string().guid({ version: 'uuidv4' }),
  gender: Joi.string().valid('male', 'female'),
  phone: Joi.string().min(10).max(10),
  email: Joi.string().email({ tlds: { allow: false } }),
  darshanEmail: Joi.string().email({ tlds: { allow: false } }).regex(/@darshan\.ac\.in$/),
  enrollmentNumber: Joi.string().min(5).max(15),
  game: Joi.string().valid(...constants.gameNames),
  university: Joi.string().valid(...constants.universityNames),
  semester: Joi.number().min(1).max(8),
  tShirtSize: Joi.string().valid('XS', 'S', 'M', 'L', 'XL', 'XXL'),
  password: Joi.string().min(6).max(50),
};

export default ValidationSchema;
